import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-stakeholders-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-stakeholders-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { ApplicationCreateService } from "../../../../create-application/shared/application-create.service";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { ViewApplicationStakeholdersItamsConstants } from "./view-application-stakeholders-itams.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import RecipientUtils from "../../../../shared/utils/recipient-utils";
export let ViewApplicationStakeholdersItamsComponent = class ViewApplicationStakeholdersItamsComponent extends ViewApplicationBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    recipientService;
    applicationViewService;
    changeDetectorRefs;
    routerParamsService;
    tradersForm;
    disableTraderRecipientFilter = true;
    traderConfigurableLabel = "Trader";
    tradersFormControlName = ViewApplicationStakeholdersItamsConstants.TRADERS_CONTROL_NAME;
    traderDisableAddButton = true;
    traderRecipientGroups = [];
    traderDisableEditButton = true;
    traderDisableDeleteButton = true;
    stepHeader;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, recipientService, applicationViewService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.recipientService = recipientService;
        this.applicationViewService = applicationViewService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    ngOnInit() {
        this.initForm();
        this.subscribeToSelectedModuleName();
        this.getTraders();
    }
    loadMetadata(stepMeta) {
        this.traderRecipientGroups = stepMeta.traderGroup;
        this.changeDetectorRefs.markForCheck();
    }
    getTradersControl() {
        return this.tradersForm.get(this.tradersFormControlName);
    }
    handleRouteChange() {
    }
    subscribeToSelectedModuleName() {
        this.applicationCreateService.selectedModuleNameAsObservable.subscribe(() => {
            const header = `${ViewApplicationStakeholdersItamsConstants.STAKEHOLDERS_HEADER}`;
            this.stepHeader = header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRefs.markForCheck();
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(ViewApplicationStakeholdersItamsConstants.TRADERS_FORM_GROUP_NAME);
        this.tradersForm = form;
    }
    getTraders() {
        const params = {
            $filter: `(jobId eq ${this.jobId} and moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false and groups/any(c: c/groupName eq 'Other')) or (jobId eq ${this.jobId} and moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false and groups/any(c: c/groupName eq 'Trader'))`,
            $expand: `groups`
        };
        this.recipientService.getRecipientsObservable(params).subscribe({
            next: (recipientArray) => {
                this.onGetTradersCompleted(recipientArray);
                this.changeDetectorRefs.detectChanges();
            }, error: err => {
                this.appControllerService.handleServerErrorMessage("traders", err, CRUDOperation.Get);
            }
        });
    }
    onGetTradersCompleted(recipientArray) {
        if (recipientArray && recipientArray.length > 0) {
            const tradersControl = this.tradersForm.get(this.tradersFormControlName);
            RecipientUtils.setRecipients(recipientArray, true, tradersControl);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: RecipientService },
        { type: ApplicationViewService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationStakeholdersItamsComponent = __decorate([
    Component({
        selector: "app-view-application-stakeholders-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationStakeholdersItamsComponent);
